import { TripRequestEmbedRead } from 'src/common/external/bambi-api/bambiApi';
import { BAMBI_API_BASE_URL } from 'src/common/external/bambi-api/constants';

import { EMBED_COPY_WARNING } from './constants';

export function generateTripRequestEmbedHTML(
  tripRequestEmbed: TripRequestEmbedRead
) {
  return `<!-- IMPORTANT: ${EMBED_COPY_WARNING} -->
<iframe
  title="Trip Request Form"
  src="${BAMBI_API_BASE_URL}public/trips/embed/trip-request/?access_token=${tripRequestEmbed.public_token}"
  style="
    width: 100%;
    height: 100%;
  "
></iframe>
`;
}
